export default {
  title: 'Acompanhe a sua encomenda',
  text: 'Obrigado por encomendar aqui! A nossa parceria com <0>{{carrier}}</0> permite-nos gerir as entregas diretamente no nosso site, poupando {{savings}} em média em comissões de entrega. A sua encomenda será entregue por <1>{{carrier}}</1>, garantindo um excelente serviço 😊',
  labels: {
    delivered_by: 'Entregue por',
  },
  buttons: {
    track_order: 'Receber atualizações em tempo real →',
    track_order_once_confirmed: 'Receber atualizações em tempo real após confirmação',
  },
};
